module.exports = __webpack_public_path__ + "media/images/icon/chevron-left-771487fe6071e5c1f0fae3f9a19a2fbb.png";